import { Crop } from '../../Models/Geometry/Crop/Crop';
import { PercentCrop } from '../../Models/Geometry/Crop/PercentCrop';
import { VideoSource } from './VideoSource';

export class MediaDeviceVideoSource implements VideoSource {
  public moonNameCrop: Crop = new PercentCrop(19, 73, 64, 9);

  public constructor(private mediaStream: MediaStream) {}

  public setVideo(video: HTMLVideoElement): void {
    if (this.mediaStream) {
      video.srcObject = this.mediaStream;
      video.load();
      video.play();
    }
  }
}
